var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8191 3.99756C7.64938 3.99756 4.37451 6.93638 3.97116 10.9976C3.92476 11.4647 3.41093 12.0262 2.83818 11.9494C2.33983 11.8826 1.95052 11.3217 1.99692 10.8546C2.48582 5.93209 6.76733 1.99756 11.8191 1.99756C15.8151 1.99756 19.2474 4.55262 20.75 7.9905C20.938 8.42066 20.8444 9.05241 20.3776 9.32846C19.8623 9.63314 19.1187 9.25251 18.9307 8.82236C17.689 5.98147 15.1156 3.99756 11.8191 3.99756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8618 3.00357C21.4083 2.96253 21.8499 3.53058 21.8499 4.00002V8.40002C21.8499 9.20084 21.2007 9.85002 20.3999 9.85002H15.9999C15.5304 9.85002 15.1851 9.46815 15.1499 9.00002C15.1117 8.49245 15.5304 8.01192 15.9999 8.01192H20.0118V4.00002C20.0118 3.53058 20.3517 3.04186 20.8618 3.00357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1526 20.0039C16.3223 20.0039 19.6123 16.9772 20.0157 12.916C20.0621 12.4489 20.5739 12.1074 21.0843 12.1542C21.5906 12.2006 22.0421 12.6169 21.9957 13.084C21.5068 18.0065 17.204 22 12.1523 22C8.1563 22 4.64677 19.5222 3.14419 16.0843C2.95618 15.6542 3.22968 15.0758 3.65983 14.8878C4.08998 14.6998 4.67421 14.813 4.86222 15.2432C6.10388 18.0841 8.85602 20.0039 12.1526 20.0039Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1221 20.8499C2.61863 20.876 2.15046 20.4694 2.15046 19.9999V15.5999C2.15046 14.7991 2.79965 14.1499 3.60046 14.1499H7.00046C7.4699 14.1499 7.85451 14.5886 7.85059 15.081C7.84669 15.5691 7.4699 15.9972 7.00046 15.9972H3.99778V19.9999C3.99778 20.4694 3.59804 20.8252 3.1221 20.8499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.c2dda8fbcf93a5528620dd06f38a88ff.svg";
export { ForwardRef as ReactComponent };